import React from "react"
import {
  SectionWrapper,
  DetailList,
  DetailListItem,
  SectionImageBox,
  SectionImage,
  SectionTitleDesktop,
  SectionTitleMobile,
} from "../landing-section.styles"
import styled from "styled-components"

import CedentePlatform from "../../../images/cedente-plataforma.png"

export const SectionClientDivisor = styled.div`
  order: 2;

  @media screen and (min-width: 1100px) {
    order: 0;
    flex-basis: 380px;
  }
`

export default function SectionClient() {
  return (
    <section>
      <SectionWrapper>
        <SectionClientDivisor>
          <SectionTitleDesktop>
            Rápido e fácil para <br /> o <b>Cliente</b>
          </SectionTitleDesktop>
          <DetailList>
            <DetailListItem>
              O upload de arquivos é simples e a plataforma é intuitiva. Você
              dedica seu tempo para cuidar do seu negócio.
            </DetailListItem>
            <DetailListItem>
              Integração com os principais <b>ERPs</b>
            </DetailListItem>
          </DetailList>
        </SectionClientDivisor>
        <div>
          <SectionImageBox>
            <SectionTitleMobile>
              Rápido e fácil para <br /> o <b>Cliente</b>
            </SectionTitleMobile>
            <SectionImage src={CedentePlatform} data-zoomable />
          </SectionImageBox>
        </div>
      </SectionWrapper>
    </section>
  )
}
